import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

const Wrapper = styled.div`
  margin: 56px 0 0 60px;
  background-color: #e4e5e7;

  ${mediaMaxWidth.tablet} {
    margin: 56px 0 0 0;
  }
`;

export { Wrapper as default };
